import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class WrongFirstAdvanceDocumentIdError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.first-advance-document.wrong-id');
    }
}
